var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dft-container",style:([_vm.container_Style])},[_c('div',{staticClass:"dft-richtext_box",style:([_vm.richtext_box_Style])},[_c('div',{staticClass:"rqe-box",domProps:{"innerHTML":_vm._s(_vm.richTextData)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }